module.exports = __webpack_public_path__ + "static/image/history/m/201812@3x.jpg?bb5cc359";